/**
 * Created on 2025-06-13
 */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import { connect } from 'react-redux'

import SupervisionTable from './SupervisionTable'
import Heading from 'uiKit/texts/Heading'
import { isQcsBot } from 'constants/qcs'

const styles = theme => ({
  container: {
    maxWidth: 927,
    minHeight: 585,
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '40px',
  },
})

const SurveysSupervision = ({ classes, activeBot }) => {
  const isQcs = isQcsBot(activeBot)
  return (
    <div>
      <div className={classes.container}>
        <Heading>{isQcs ? 'Supervision' : 'Surveys & Supervision'}</Heading>
        <SupervisionTable />
      </div>
    </div>
  )
}

SurveysSupervision.propTypes = {
  classes: PropTypes.object.isRequired,
  activeBot: PropTypes.object,
}

const mapStateToProps = state => ({
  activeBot: state.activeBot,
})

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(SurveysSupervision))
